import { ModalAddSiteComponent } from './../../../shared/components/modals/modal-add-site/modal-add-site.component';
import { Ca1Model } from './../../../shared/models/societe-linked/ca1.model';
import { Ca1Service } from './../../../shared/services/societe-linked/ca1.service';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';

@Component({
  selector: 'app-gestion-site',
  templateUrl: './gestion-site.component.html',
  styleUrls: ['./gestion-site.component.scss']
})
export class GestionSiteComponent {

  @Output() onUpdated = new EventEmitter<boolean>();
  societe: SocieteModel;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: SiteModel;
  displayedColumns: string[] = ['code', 'libelle', 'rSociale', 'adr', 'adrFact', 'tel', 'type', 'ca1', 'siret', 'naf', 'email', 'action'];
  dataSource: SiteModel[];
  matDataSource = new MatTableDataSource<SiteModel>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  sites: SiteModel[] = [];
  ca1s: Ca1Model[] = [];
  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  constructor(private router: Router,
              public dialog: MatDialog,
              private ca1Service: Ca1Service,
              injector: Injector,
              private route: ActivatedRoute,
              private toastr: ToastrService,
              private societeService: SocieteService,
              private toastrService: ToastrService,
              private siteService: SiteService,
              private gestionReferentielComponent: GestionReferentielComponentService) 
              {
                this.route.params.subscribe((params: any) => {
                  if (params.id === '0') {
                    this.toastrService.error('Erreur durant la récupération du ca1.', 'Erreur');
                    this.router.navigate(['/']);
                  } else {
                    this.societeService.get(params.id).subscribe((societe: SocieteModel) => {
                      if (societe) {
                       this.societe = societe;
                       this.objet.query = '';
                       this.objet.pageNumber = 0;
                       this.objet.pageSize = this.pageSize;
                       this.objet.order = 'libelle';
                       this.matDataSource.paginator = this.paginator;
                       this.loadPage();
                       this.ca1Service.getFromSociete(this.societe.id).subscribe(ca1s => {
                        this.ca1s = ca1s;
                      });
                      }
                    });
                  }
                });
                this.router.routeReuseStrategy.shouldReuseRoute = function() {
                   return false;
                 };
                this.mySubscription = this.router.events.subscribe((event) => {
                   if (event instanceof NavigationEnd) {
                     this.router.navigated = false;
                   }
                 });
              }

  getCa1ByCode(code: string): string{
    const c = this.ca1s.find(ca1 => ca1.code === code);
    if (c) {
      return c.code + '-' + c.libelle;
    } else {
      return '';
    }
  }


  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateSiteFormGroup();
    form.get('idSociete').setValue(this.societe.id);
    const dialogRef = this.dialog.open(ModalAddSiteComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          sites: this.sites,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });

  }

  onModify(site: SiteModel): void {
    const form = this.gestionReferentielComponent.getEditSiteFormGroup(site);
    const dialogRef = this.dialog.open(ModalAddSiteComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          ca1s: this.sites,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(ca1: SiteModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du site',
        message: 'Êtes-vous sur de vouloir supprimer le site ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.siteService.delete(ca1.id).subscribe((response: SiteModel) => {
          this.toastrService.success('Le site a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }

  orderUsers(sites: SiteModel[]): SiteModel[] {
    sites = sites.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return sites;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.societe.id;
    this.siteService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<SiteModel>) => {
      if (query.objets != null) {
        this.sites = query.objets;
      } else {
        this.sites = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<SiteModel>(this.sites);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

}
